//
// Generated class AdyenCore
//

/// <reference path="AdyenCore_ManagedObject.ts" />

class AdyenCore extends AdyenCore_ManagedObject
{

}
